import { render, staticRenderFns } from "./DegradedModeBanner.vue?vue&type=template&id=7b83a6c2&scoped=true"
import script from "./DegradedModeBanner.vue?vue&type=script&lang=js"
export * from "./DegradedModeBanner.vue?vue&type=script&lang=js"
import style0 from "./DegradedModeBanner.vue?vue&type=style&index=0&id=7b83a6c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83a6c2",
  null
  
)

export default component.exports